import React from "react";
import Dropdown from "../DropDown";
import { useAssetContext } from "../../DataContext/AssetContext";

interface ResourceDropdownProps {
  selectedValue: string;
  onChange: (value: string) => void;
  disabled?: boolean;
  className?: string;
}

const ResourceDropdown: React.FC<ResourceDropdownProps> = ({
  selectedValue,
  onChange,
  disabled = false,
  className = "w-full p-1 sm:p-1 pl-4 pr-16 border border-gray-300 rounded-lg bg-[#f6f6f6] text-[#000000] shadow-inner text-xs md:text-base appearance-none",
}) => {
  const { resourceNames } = useAssetContext();
  
  const options = resourceNames.map((name) => ({
    label: name, 
    value: name, 
  }));

  return (
    <Dropdown
      options={options}
      selectedValue={selectedValue}
      onValueChange={onChange}
      disabled={disabled}
      className={className}
      placeholder="Select a Resource"
      showOptionTooltips
    />
  );
};

export default ResourceDropdown;
